<template>
  <br />
  <div class="home">
    <p>国任保险-海外知识产权维权法律费用损失保险</p>
    <br />
    <div class="van-hairline--surround">
      <van-cell-group inset>
        <van-field readonly label="保险机构" model-value='国任保险'/>
        <van-field readonly label="技术支持" placeholder="镖计划科技" />
        <van-field readonly label="支付方式" placeholder="美元支付" />
        <van-field readonly label="最低支付金额" model-value='3000美金'/>
        <van-notice-bar left-icon="volume-o" text="已授权专利！适用亚马逊美国站" />
      </van-cell-group>
    </div>
    <br />
    <van-cell-group inset>
      <van-grid direction="horizontal" :column-num="3">
        <van-grid-item icon="refund-o" text="10倍额度" />
        <van-grid-item icon="good-job-o" text="无免赔额" />
        <van-grid-item icon="newspaper-o" text="风险评估" />
        <van-grid-item icon="gold-coin-o" text="资金节约" />
        <van-grid-item icon="manager-o" text="专业律师" />
        <van-grid-item icon="bulb-o" text="便捷理赔" />
      </van-grid>
    </van-cell-group>
    <br/>
    <van-cell-group inset>
      <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">保险产品简介</van-divider>
      <van-field readonly label="适用平台/区域" model-value='亚马逊美国站' />
      <van-field readonly label="保费费率" model-value="USD 3000起" />
      <van-field readonly label="单次赔偿限额" model-value="USD 30,000起" />
      <van-field readonly label="累计赔偿限额" model-value="USD 30,000起" />
      <van-field readonly label="保期" model-value="一年" />
      <van-field readonly label="适用侵权类型" model-value="已授权专利" />
      <van-field readonly label="免赔" model-value="无免赔" />
      <van-field readonly label="特点1:" model-value='10倍赔偿额度，维权无忧' left-icon="smile-o" right-icon="fire-o" />
      <van-field readonly label="特点2:" model-value="知识产权场景全覆盖" left-icon="manager-o" />
      <van-field readonly label="特点3:" model-value="专有美国律师资源，保障维权效率和结果" left-icon="good-job-o" />
    </van-cell-group>
    <br/>
    <div class="van-hairline--surround">
        <van-cell-group inset>
         <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">适合购买此保险的企业或个人:</van-divider>
       <p class="match"><van-notice-bar color="#1989fa" left-icon="friends-o">
           产品服务主要销往欧洲、美国等地
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" color="#1989fa" left-icon="logistics">
           企业的产品具有独特的创新，具有市场优势
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" color="#1989fa" left-icon="warn-o">
           潜在行业竞争激烈，且有国外有同等竞争对手
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" color="#1989fa" left-icon="more-o">
           过去涉及法律诉讼，无论是被告还是原告
         </van-notice-bar>
         <van-notice-bar color="#1989fa" left-icon="closed-eye">
           有已授权的专利，专利较为密集
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" left-icon="setting-o">
          如果您有这方面情况，建议购买此保险进行维权防护
         </van-notice-bar>
       </p>
     </van-cell-group>
   </div>
   <br/>
    <van-cell-group inset>
      <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">投保流程</van-divider>
      <van-steps direction="vertical" :active="3">
          <van-step>
              <h3>专利权人确认投保意向</h3>
              <p>1个工作日</p>
          </van-step>
          <van-step>
              <h3>风险核查</h3>
              <p>资料采集完整后，7个工作日内</p>
          </van-step>
          <van-step>
              <h3>审核通过支付保费</h3>
               <p>1个工作日</p>
          </van-step>
          <van-step>
              <h3>出具保单</h3>
               <p>3个工作日内</p>
          </van-step>
    </van-steps>
    </van-cell-group>
    <br/>
    <van-cell-group inset>
      <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">理赔流程</van-divider>
      <van-steps direction="vertical" :active="3">
          <van-step>
              <h3>维权上报</h3>
              <p>投保人需要维权的第一时间上报</p>
          </van-step>
          <van-step>
              <h3>律师确认</h3>
              <p></p>
          </van-step>
          <van-step>
              <h3>方案沟通</h3>
               <p>基于本案件进行进一步确认沟通</p>
          </van-step>
          <van-step>
              <h3>理赔</h3>
               <p>根据维权结果和保险承保范围，进行理赔</p>
          </van-step>
        </van-steps>
    </van-cell-group>
  </div>
  <br/>
  <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">镖计划具备最健全的知识产权保护服务</van-divider>
 <van-config-provider :theme-vars="themeVars2">
   <div class="van-hairline--surround">
     <van-cell-group inset border="false">
       <p class="text3Indentation">1、我们已经为1万+涉外企业或个人提供过基于知识产权的保护建议和方案</p>
       <p class="text3Indentation">2、国内首创的金融保障方式，进一步降低企业或个人的涉诉损失风险</p>
       <p class="text3Indentation">3、全套闭环服务流程，一站式解决企业或个人的涉诉所有问题</p>
     </van-cell-group>
   </div>
   <div style="margin: 16px;">
   <van-button color="linear-gradient(to right, #f67f34, #d55809)" block size="large" to="/binding">我想参与</van-button>
 </div>
 </van-config-provider>
</template>
<script>
</script>
<style scoped>

.text3Indentation {
 text-align: left;
 font-weight: bold;
 font-size: 14px;
 padding-top: 1em;
 padding-right: 1em;
 padding-bottom: 1em;
 padding-left: 1em;
}
</style>


